import { useMarkets } from "@/api/use-markets";

import type { FilterOptionsResult } from "../types";

/**
 * Location picker options for filter fields — the full location reference set,
 * sorted by `order` and cached for the session (`locations` is the REST v5 name
 * for the `Market` table). Small enough to load in one page, so there is no
 * server search or paging: the Command input filters the options client-side.
 */
export function useLocationFilterOptions(): FilterOptionsResult {
  const { data: locations = [], isLoading } = useMarkets();

  return {
    options: locations.map((location) => ({
      value: location.id,
      label: location.name,
    })),
    isLoading,
  };
}
